<ng-container *appTranslate="let t">
  <form class="dialog-form" [formGroup]="form" (ngSubmit)="save()">
    <div class="col">
      <new-ui-checkbox [label]="t('enabled.title')" formControlName="enabled" />

      @if (form.controls.enabled.errors?.required) {
        <p-message variant="simple" severity="error" size="small">
          {{ t("required") }}
        </p-message>
      }
    </div>

    <div class="col">
      <p-floatlabel variant="in">
        <new-ui-activity-type-selector inputId="activities" formControlName="activities" />

        <label for="activities">{{ t("activityType.title") }}</label>
      </p-floatlabel>

      @if (form.controls.activities.errors?.required) {
        <p-message variant="simple" severity="error" size="small">
          {{ t("required") }}
        </p-message>
      }
    </div>

    <div class="col">
      <new-ui-multiselect [label]="t('scope.title')" [options]="scopes" [showClear]="true" formControlName="scopes" />

      @if (form.controls.scopes.errors?.required) {
        <p-message variant="simple" severity="error" size="small">
          {{ t("required") }}
        </p-message>
      }
    </div>

    <div class="col">
      <p-floatlabel variant="in">
        <new-ui-document-type-selector inputId="documents" formControlName="documents" />

        <label for="documents">{{ t("documentType.title") }}</label>
      </p-floatlabel>

      @if (form.controls.documents.errors?.required) {
        <p-message variant="simple" severity="error" size="small">
          {{ t("required") }}
        </p-message>
      }
    </div>

    <div class="col">
      <new-ui-button [fluid]="true" [label]="t('common.save')" icon="icon-[mi--checkmark-medium]" type="submit" />

      <new-ui-button
        [fluid]="true"
        [label]="t('common.close')"
        icon="icon-[mi--close-medium]"
        severity="secondary"
        type="reset"
        (onClick)="close()"
      />
    </div>
  </form>
</ng-container>
